namespace TabAurous.Reports {


    export class CustomerSalesOptions {
        items: TabAurous.Sales.SalesItemsRow[];
    }

    export class CustomerSalesPanel extends Serenity.TemplatedPanel<CustomerSalesOptions> {
        constructor(container: JQuery, opt: CustomerSalesOptions) {
            super(container, opt);

            //Grouping
            var items = this.options.items;


            var name = 'P1';
            var data = [1, 2, 3];

            var namearray = [name];
            var customerarray = [name];
            var dataarray = [data];
            namearray.pop();
            dataarray.pop();
            customerarray.pop();
            var customers = [name];
            customers.pop();
            for (var i = 0; i < items.length; i++) {
                var exists = false;
                for (var k = 0; k < customers.length; k++) {
                    if (items[i].LedgerName == customers[k]) {
                        exists = true;
                    }
                }
                if (!exists) {
                    customers.push(items[i].LedgerName);
                }
            }
            for (var c = 0; c < customers.length; c++) {
                for (var i = 0; i < items.length; i++) {
                    var exists = false;
                    for (var k = 0; k < namearray.length; k++) {
                        if (items[i].CategoryName == namearray[k]) {
                            if (items[i].LedgerName == customers[c]) {
                                if (dataarray[k][c] == undefined)
                                    dataarray[k][c] = items[i].GrossAmount;
                                else
                                    dataarray[k][c] += items[i].GrossAmount;

                                dataarray[k][c] = parseFloat(dataarray[k][c].toFixed(2));
                            }
                            exists = true;
                        }
                    }
                    if (!exists) {
                        namearray.push(items[i].CategoryName);
                        var newdata = new Array<number>(customers.length);
                        newdata[c] = items[i].GrossAmount;
                        newdata[c] = parseFloat(newdata[c].toFixed(2));
                        dataarray.push(newdata);
                    }
                }
            }

            var ser = [{ name, data }];
            ser.pop();
            for (var i = 0; i < namearray.length; i++) {
                name = namearray[i];
                data = dataarray[i];
                var newseries = { name, data };
                ser.push(newseries);
            }


            var options = {
                series: ser,
                chart: {
                    fontFamily: '"PT Sans", sans-serif',
                    type: 'bar',
                    height: 270,
                    width:850,
                    stacked: true,
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: true
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                plotOptions: {
                    bar: {
                        horizontal: false,
                    },
                },
                xaxis: {
                    categories: customers,
                },
                legend: {
                    position: 'right',
                    offsetY: 40
                },
                fill: {
                    opacity: 1
                }
            };

            //            var x = document.getElementById('TabAurous_Reports_CustomerSalesPanel13_chartContainer');
            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);

            chart.render();
        }

        getTemplate() {

            return `<div id="~_chartContainer"></div>`;
        }
    }






    export var finid = [];
    export var companyids = [];
    export var vendorids = [];
    export var baseitemid = [];
    export var typeids = [];
    export var subtypeids = [];
    export var applyfilter = false;
    import fld = Sales.SalesMasterRow.Fields;
    @Serenity.Decorators.registerClass()
    export class CustomerSalesItemsGrid extends Serenity.EntityGrid<TabAurous.Sales.SalesItemsRow, any> {
        protected getColumnsKey() { return 'Sales.CustomerSalesItems'; }
        protected getDialogType() { return TabAurous.Sales.SalesItemsDialog; }
        protected getIdProperty() { return TabAurous.Sales.SalesItemsRow.idProperty; }
        protected getInsertPermission() { return TabAurous.Sales.SalesItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.Sales.SalesItemsRow.localTextPrefix; }
        protected getService() { return TabAurous.Sales.CustomerSalesItemsService.baseUrl; }
        private chartContainer: JQuery;
        private chartPanel: CustomerSalesPanel;
        constructor(container: JQuery) {
            super(container);
            this.setTitle("");

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
      

            this.addDateRangeFilter("TransDate", "Date");
     
        

            this.addQuickFilter({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        companyids = temp;
                    }
                    w.active = false;
                    w.handled = true;
                    return false;
                },

                cssClass: 'hidden-xs'

            });


        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('GrossAmount'),
                    new Slick.Aggregators.Sum('NetAmount')
                ]
            });

            this.view.setGrouping([{ getter: 'LedgerName' }]);

            return grid;
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }
        //protected getColumns() {
        //    var columns = super.getColumns();

        //    Q.first(columns, x => x.field === 'GrossAmount')
        //        .groupTotalsFormatter = (totals, col) =>
        //            (totals.sum ? (Q.coalesce(totals.sum[col.field], '')) : '');

        //    return columns;
        //}
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            


            return filters;
        }
        onViewProcessData(response: Serenity.ListResponse<TabAurous.Sales.SalesItemsRow>) {

            if (!this.chartContainer) {
                this.chartContainer = $("<div style='padding: 20px 0' />");
                this.chartContainer.insertBefore(this.element.find(".grid-container"));
            }

            if (this.chartPanel) {
                this.chartPanel.destroy();
            }

            this.chartPanel = new CustomerSalesPanel(this.chartContainer, { items: response.Entities });

            var options = {
                chart: {
                    type: 'bar'
                },
                series: [
                    {
                        name: 'sales',
                        data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
                    }
                ],
                xaxis: {
                    categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
                }
            }

            var chart = new ApexCharts(document.querySelector(".chartContainer"), options);

            chart.render();


            return response;
        }

        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            //buttons.push({

            //      title: 'Print Register',
            //      cssClass: 'export-pdf-button',
            //      //icon: 'fa-cloud-download',
            //      onClick: () => {
     
            //          Common.ReportHelper.execute({
            //              reportKey: 'Reports.ApprovalRegister',
            //              params: {
            //                  CompanyIds: this.view.params.CompanyIds,
            //                  FinIds: this.view.params.FinancialYearIds,
            //                  VendorIds: this.view.params.VendorIds,
            //                  date: this.view.params.Criteria
            //              }
            //          });
            //      }
            //  }
            //)
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                title: "Print",
                reportTitle: "Cistomer Sales",
                onViewSubmit: () => this.onViewSubmit()
            }))
                ,
                ({
                    title: 'Apply Filter',
                    cssClass: '',
                    icon: 'fa-filter',
                    onClick: () => {
                        applyfilter = true;
                        if (companyids.length != 0) {
                            (this.view.params as ReportFiltersRequest).CompanyIds = companyids;

                        } if (finid.length != 0) {
                            (this.view.params as ReportFiltersRequest).FinancialYearIds = finid;
                        } if (vendorids.length != 0) {
                            (this.view.params as ReportFiltersRequest).VendorIds = vendorids;
                        }
                        var request: ReportFiltersRequest = {
                            VendorIds: vendorids,
                            CompanyIds: companyids,
                            FinancialYearIds: finid,
                            BaseItemTypeIds: baseitemid,
                            CategoryIds: typeids,
                            SubCategoryIds: subtypeids
                        }
                        Sales.CustomerSalesItemsService.List(request, response => {
                            this.setItems(response.Entities);
                            //this.refresh();
                        }, { async: false, blockUI: true });


                    }

                });
            return buttons;
        }
    }

}